import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as User from '../../helpers/User';
import * as Common from '../../helpers/Common';
import IseekObservers from './IseekObservers';
import IseekAssessors from './IseekAssessors';
import IseekOthers from './IseekOthers';
import IseekCreateform from './IseekCreateform';
import IseekSavedform from './IseekSavedform';
const $= window.$;


class IseekForm extends Component {
	constructor(props) {
		super(props);
		this.state={
            Observers : [],
            Assessors : [],
            Others : [],
            savedForms:[],
            polldata:'',
            mails:"",
            ids:[],
            idsarray:[],
            editsele: '',
        };
       this.getData = this.getData.bind(this);
       this.getEmails = this.getEmails.bind(this);
       this.onSubmit = this.onSubmit.bind(this);
       this.clearForm = this.clearForm.bind(this);

	}

	clearForm(){

		this.setState({
			 polldata:'',
			 mails : '',
		})
	}
	

	

	onSubmit(e){
		Common.reactLoader("show", "Please wait...");
		let learnerID = Common.getUserData("id", true);
		var pollid  = this.state.polldata ;
		 	pollid = pollid.split('_');
		 	pollid = pollid[0];

		let domain = Config.domainUrl;
		 	//alert(JSON.stringify(this.state.ids));
		// var  date = new Date();
		// alert(pollid);
		fetch(Config.domainUrl+'iseek/assign-assessor', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    learner_id:learnerID,roles:this.state.idsarray, snap_poll_id_fk : pollid, snap_assessor_id_fk: this.state.ids,domain:domain
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               	Common.reactLoader("hide");
               	//alert(responseJson.status);
               if (responseJson.status == 0) {
			        Common.message(responseJson.message, responseJson.errors, "error");
			      } else {
			      	this.clearForm();
			        Common.message("", responseJson.message, "success");
			         if($('input[type="checkbox"]').is(':checked')){
				    	$('input[type="checkbox"]').prop('checked',false);
				    }
				    $("#seekfeedback-right").css('display','none');

			        //$("#viewfeed").click();
			      }


   		 });
	}



	getData(data){
		// alert(data);
         this.setState({
         	polldata: data,
        });

    }
    getEmails(ids){
    	//alert(emails);
    	Common.reactLoader("show", "Please wait...");
    	let learnerID = Common.getUserData("id", true);

    	fetch(Config.domainUrl+'personal/getmails', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    learner_id:learnerID, role_id : ids
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               	Common.reactLoader("hide");
               	//alert(JSON.stringify(responseJson));
               	if(responseJson.status != 0){
               		
	               	this.setState({
	               		mails: responseJson.mails,
	               		ids: responseJson.ids,
	               		idsarray:responseJson.idsarray
	               	});
               	}

   		 });

    }

    // show(){

		
    // }

    // showmail(){

    // }




	   getSeekTables(){
	   	let learnerID = Common.getUserData("id", true);

	   	let mentor = Common.getUserData('mentor',true);
    	fetch(Config.domainUrl+'personal/iseek-tables', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()

                },

                  body: JSON.stringify({
                    learner_id:learnerID,mentor:mentor
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               	if(responseJson.status != 0){

	                this.setState({
	                    Observers : responseJson.Observers,
	                    Assessors : responseJson.Assessors,
	                    Others : responseJson.Others,
	                    savedForms : responseJson.savedForms
	                });
               	}


   		 });

    }


     componentDidMount() {
        this.getSeekTables();
								setTimeout(()=>{

									$(".accordion_coach1").smk_Accordion();
								},500)
    }



		render() {
			// alert(this.state.polldata);
	        if(this.state.polldata != "" && this.state.polldata != "undefined"){
				// this.show();
				$("#seekfeedback-right").css('display','block');
		    }
			var polltitle  = this.state.polldata ;
		 	polltitle = polltitle.split('_');
		 	polltitle = polltitle[1];

		 	 if(this.state.mails != "" && this.state.mails != "undefined"){
				$("#divToaddress").css('display','none');
				// this.showmail();
		    }
		    else if(this.state.mails == ''){
				$("#divToaddress").css('display','block');
		    }

			//alert(JSON.stringify(this.state.editsele));
			return (
				<div className="feedbk-tab1">
				  	<div className="clear"></div>
				  	<strong>Collect responses to your feedback!</strong>
				 	 <div className="clear"></div>
				    	Send your Feedback Form to your Observers, Assessors, or anybody else you'd like to. Choose the people from the groups, or type in a valid email ID below, and send.
				  	<div className="clear"></div>
				    <div className="seekfeedback-left">
					    <div className="accordion_coach1">
						    <div className="accordion_in">
						        <div className="acc_head rgtDiv">Create a new form
						        </div>
						       	 <div className="acc_content" style={{display:'none'}}>
						       	 	<IseekCreateform />
						         </div>
						    </div>
					      	<div className="accordion_in">
					          <div className="acc_head rgtDiv" id="savedform" onClick={(e)=>this.getSeekTables(e)}>Use a saved form</div>
					          <div className="acc_content" style={{display:'none'}}>
					            <IseekSavedform  savedForms={this.state.savedForms}  sendData={this.getData}/>
					          </div>
					      	</div>
					      	<div className="accordion_in" >

					            <div className="acc_head rgtDivShw color">My Observers</div>
					            <div className="acc_content" style={{display: 'none'}}>
					          		<IseekObservers Observers={this.state.Observers} sendEmails={this.getEmails}/>
					            </div>
					      	</div>
						    <div className="accordion_in">
						          <div className="acc_head rgtDivShw color" >My Assessors</div>
						          <div className="acc_content" style={{display: 'none'}}>
						            <IseekAssessors Assessors={this.state.Assessors} sendEmails={this.getEmails}/>
						          </div>
						    </div>
						    <div className="accordion_in">
						          <div className="acc_head rgtDivShw color" >My other contacts</div>
						          <div className="acc_content" style={{display: 'none'}}  id="others">
						           	<IseekOthers Others={this.state.Others} getSeekTables={(e)=>this.getSeekTables()} sendEmails={this.getEmails}/>
						          </div>
						    </div>
					    </div>
					</div>
					<div className="seekfeedback-right" id="seekfeedback-right" style={{display:'none'}} >
					  <ul>
					      <li><strong>Form Title:</strong></li>
					      <li className="blue-bg">
					      	{polltitle}
					       </li>
					      <li><strong>To:</strong></li>
					      <li className="grey-border">
					      	<span dangerouslySetInnerHTML={{__html: this.state.mails}}/>
					        <div id="divToaddress" style={{display:'block'}}>Please select the people from your Observers, Assessors, or Others to send this feedback form to</div>
					      </li>
					  </ul>
					  <div className="fdbk-btn">
					  	<input type="hidden" value={this.state.mails}/>
					    <input type="button" name="btnSend" id="" value="Send" className="button-accept" alt="Send" title="Send" onClick={(e)=>this.onSubmit(e)}/>
					  </div>
					</div>
				</div>
			);
		}
}

export default IseekForm;



// WEBPACK FOOTER //
// ./src/personal_interactions/iseek/IseekForm.js